// import React, {useCallback, useEffect, useRef, useState} from 'react';
// import useLocalNotification from './localNotificationHandler';
// import useLocalNotificationJSONManager from './useLocalNotificationJSONManager';
// import AsyncStorage from '@react-native-async-storage/async-storage';
// import {useFocusEffect} from "@react-navigation/native";
//
// const PROCESSED_IDS_KEY = 'processedGroupIds';
//
// const checkReminderMessagesFunction = () => {
//     const {
//         scheduleNotification,
//         scheduleRecurringNotification,
//         getAllScheduledNotifications,
//         cancelNotification
//     } = useLocalNotification();
//     const {
//         notificationGroups,
//         createNotificationGroup,
//         updateNotificationGroup,
//         deleteNotificationGroup,
//         loadNotificationGroups,
//         saveNotificationGroups,
//         createNotificationGroupFromDetails
//     } = useLocalNotificationJSONManager();
//     const [notifGroups, setNotifGroups] = useState(null);
//     const processingQueueRef = useRef(Promise.resolve());
//
//     // Load notification groups once on mount
//     useCallback(() => {
//         console.log('Component is in view, loading notification groups from storage...');
//         const fetchNotifGroups = async () => {
//             const storedGroupsJson = await AsyncStorage.getItem('localNotificationGroups');
//             if (storedGroupsJson !== null) {
//                 setNotifGroups(JSON.parse(storedGroupsJson));
//                 console.log('Notification groups loaded:', storedGroupsJson);
//             } else {
//                 console.log('No stored notification groups found.');
//             }
//         };
//         fetchNotifGroups();
//
//         return () => {
//             console.log('Cleaning up');
//         };
//     }, [])
//
//     // Effect to check and update reminders when notifGroups changes
//     useEffect(() => {
//         if (notifGroups) {
//             console.log('Checking for reminders to update...');
//             checkToUpdateReminders(notifGroups);
//         }
//     }, [notifGroups]);
//
//     const checkToUpdateReminders = async (notificationGroups) => {
//         const currentTimeStamp = Date.now();
//         //const timeToProcess = 604800000; // one week
//         const timeToProcess = 10000; // 10 seconds
//         //const timeToProcess = 60 * 60 * 1000;
//         const processedIds = await AsyncStorage.getItem(PROCESSED_IDS_KEY) || '[]';
//         const processedIdsArray = JSON.parse(processedIds);
//
//         notificationGroups.forEach(group => {
//             if (currentTimeStamp - group.messageModified > timeToProcess && !processedIdsArray.includes(group.id)) {
//                 console.log(`Scheduling update for group ID ${group.id}...`);
//                 enqueueUpdate(group.id, group.originalTimestamp, group.days, processedIdsArray);
//             } else {
//                 console.log(`Group ID ${group.id} duplicate or not enough time has passed to process.`);
//             }
//         });
//     };
//
//     const enqueueUpdate = (groupId, time, days, processedIdsArray) => {
//         processingQueueRef.current = processingQueueRef.current.then(async () => {
//             console.log(`Processing update for group ID ${groupId}...`);
//             return updateReminderMessaging(groupId, time, days, processedIdsArray);
//         }).catch(error => {
//             console.error('Error in processing queue:', error);
//             return Promise.resolve();
//         });
//     };
//
//     const updateReminderMessaging = async (groupId, time, days, processedIdsArray) => {
//         if (processedIdsArray.includes(groupId)) {
//             console.log(`Group ID ${groupId} already processed, skipping...`);
//             return false; // indicate skipped
//         }
//
//         processedIdsArray.push(groupId);
//         await AsyncStorage.setItem(PROCESSED_IDS_KEY, JSON.stringify(processedIdsArray));
//         console.log(`Group ID ${groupId} added to processed IDs.`);
//
//         await handleCancelNotificationGroup(groupId);
//         const notifications = await scheduleRecurringNotification("Workout Reminder", false, time, days);
//         const result = await createNotificationGroupFromDetails(notifications);
//
//         console.log(`New Group Created for ID ${groupId}`);
//         return result;
//     };
//
//     const handleCancelNotificationGroup = async (groupId) => {
//         const groupToDelete = notifGroups.find(group => group.id === groupId);
//         if (groupToDelete) {
//             console.log(`Cancelling notifications for group ID ${groupId}...`);
//             for (const identifier of groupToDelete.identifiers) {
//                 await cancelNotification(identifier);
//             }
//             await deleteNotificationGroup(groupId);
//             console.log(`Group ID ${groupId} notifications cancelled and deleted.`);
//         }
//     };
// };
//
// export default checkReminderMessagesFunction;

import AsyncStorage from '@react-native-async-storage/async-storage';
const PROCESSED_IDS_KEY = 'processedGroupIds';
const checkReminderMessagesFunction = (
    scheduleNotification,
    scheduleRecurringNotification,
    cancelNotification,
    notificationGroups,
    {
        createNotificationGroup,
        updateNotificationGroup,
        deleteNotificationGroup,
        loadNotificationGroups,
        saveNotificationGroups,
        createNotificationGroupFromDetails
    }
) => {

    let notifGroups = null;
    let processingQueueRef = Promise.resolve();

    // Load notification groups once on mount
    const fetchNotifGroups = async () => {
        console.log('Component is in view, loading notification groups from storage...');
        const storedGroupsJson = await AsyncStorage.getItem('localNotificationGroups');
        if (storedGroupsJson !== null) {
            notifGroups = JSON.parse(storedGroupsJson);
            console.log('Notification groups loaded:', storedGroupsJson);
            // Call checkToUpdateReminders after successfully fetching notifGroups
            checkToUpdateReminders(notifGroups);
        } else {
            console.log('No stored notification groups found.');
        }
    };

    fetchNotifGroups().catch(error => {
        console.error('Error fetching notification groups:', error);
    });

    const checkToUpdateReminders = async (notificationGroups) => {
        const currentTimeStamp = Date.now();
        const timeToProcess = 604800000; // one week
        //const timeToProcess = 10000; // 10 seconds
        //const timeToProcess = 60 * 60 * 1000;
        const processedIds = await AsyncStorage.getItem(PROCESSED_IDS_KEY) || '[]';
        const processedIdsArray = JSON.parse(processedIds);

        notificationGroups.forEach(group => {
            if (currentTimeStamp - group.messageModified > timeToProcess && !processedIdsArray.includes(group.id)) {
                console.log(`Scheduling update for group ID ${group.id}...`);
                enqueueUpdate(group.id, group.originalTimestamp, group.days, processedIdsArray);
            } else {
                console.log(`Group ID ${group.id} duplicate or not enough time has passed to process.`);
            }
        });
    };

    const enqueueUpdate = (groupId, time, days, processedIdsArray) => {
        processingQueueRef = processingQueueRef.then(async () => {
            console.log(`Processing update for group ID ${groupId}...`);
            return updateReminderMessaging(groupId, time, days, processedIdsArray);
        }).catch(error => {
            console.error('Error in processing queue:', error);
            return Promise.resolve();
        });
    };

    const updateReminderMessaging = async (groupId, time, days, processedIdsArray) => {
        if (processedIdsArray.includes(groupId)) {
            console.log(`Group ID ${groupId} already processed, skipping...`);
            return false; // indicate skipped
        }

        processedIdsArray.push(groupId);
        await AsyncStorage.setItem(PROCESSED_IDS_KEY, JSON.stringify(processedIdsArray));
        console.log(`Group ID ${groupId} added to processed IDs.`);

        await handleCancelNotificationGroup(groupId);
        const notifications = await scheduleRecurringNotification("Workout Reminder", false, time, days);
        const result = await createNotificationGroupFromDetails(notifications);

        console.log(`New Group Created for ID ${groupId}`);
        return result;
    };

    const handleCancelNotificationGroup = async (groupId) => {
        const groupToDelete = notifGroups.find(group => group.id === groupId);
        if (groupToDelete) {
            console.log(`Cancelling notifications for group ID ${groupId}...`);
            for (const identifier of groupToDelete.identifiers) {
                await cancelNotification(identifier);
            }
            await deleteNotificationGroup(groupId);
            console.log(`Group ID ${groupId} notifications cancelled and deleted.`);
        }
    };
};

export default checkReminderMessagesFunction;